import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const Header = (props) => {
  const headerType = props.headerType ? props.headerType : "";

  const [headerTypeCss, setHeaderTypeCss] = useState("nh_header-menu");

  useEffect(() => {
    if (headerType) setHeaderTypeCss("h4_nh_header-menu");
  }, [headerType]);

  // if (headerType == "white_header") {
  //   setHeaderTypeCss(
  //     "header-nav-box header-nav-box-inner-page header-nav-box-3"
  //   );
  // }
  return (
    <React.Fragment>
      <>
        {/* Cursor Animation */}
        <div className="cursor1" />
        <div className="cursor2" />
        {/* ==================== Start mobile menu ================= */}
        {/* <div className="zq_mobile_menu">
          <div className="logo icon-img-100">
            <img src="assets/images/logo/w-logo.png" alt="" />
          </div>
          <div className="close-menu cursor-pointer ti-close">
            <i className="fa-sharp fa-light fa-xmark" />
          </div>
          <div className="container">
            <div className="row">
              <div className="col-lg-2">
                <div className="menu-text">
                  <div className="text">
                    <h2>Menu</h2>
                  </div>
                </div>
              </div>
              <div className="col-lg-7">
                <div className="menu-navbar">
                  <ul className="main-menu">
                    <li>
                      <div className="overflow-hidden">
                        <a href="#" className="link cursor-pointer dmenu">
                          <span className="fill-text" data-text="Home">
                            Home
                          </span>{" "}
                          <i />
                        </a>
                      </div>
                      <div className="sub-menu">
                        <ul>
                          <li>
                            <a href="index.html" className="sub-link">
                              Home 1
                            </a>
                          </li>
                          <li>
                            <a href="index-2.html" className="sub-link">
                              Home 2
                            </a>
                          </li>
                          <li>
                            <a href="index-3.html" className="sub-link">
                              Home 3
                            </a>
                          </li>
                          <li>
                            <a href="index-4.html" className="sub-link">
                              Home 4
                            </a>
                          </li>
                          <li>
                            <a href="index-5.html" className="sub-link">
                              Home 5
                            </a>
                          </li>
                        </ul>
                      </div>
                    </li>
                    <li>
                      <div className="overflow-hidden">
                        <a
                          href="about.html"
                          className="link cursor-pointer dmenu"
                        >
                          <span className="fill-text" data-text="About Us">
                            About Us
                          </span>
                        </a>
                      </div>
                    </li>
                    <li>
                      <div className="overflow-hidden">
                        <a href="#" className="link cursor-pointer dmenu">
                          <span className="fill-text" data-text="Hosting">
                            Hosting
                          </span>{" "}
                          <i />
                        </a>
                      </div>
                      <div className="sub-menu">
                        <ul>
                          <li>
                            <a href="wordpress-hosting.html">
                              Wordpress Hosting
                            </a>
                          </li>
                          <li>
                            <a href="cloud-hosting.html">Cloud Hosting</a>
                          </li>
                          <li>
                            <a href="shared-hosting.html">Shared Hosting</a>
                          </li>
                          <li>
                            <a href="email-hosting.html">Email Hosting</a>
                          </li>
                        </ul>
                      </div>
                    </li>
                    <li>
                      <div className="overflow-hidden">
                        <a href="#" className="link cursor-pointer dmenu">
                          <span className="fill-text" data-text="Page">
                            Page
                          </span>{" "}
                          <i />
                        </a>
                      </div>
                      <div className="sub-menu">
                        <ul>
                          <li>
                            <a href="hosting.html" className="sub-link">
                              Hosting
                            </a>
                          </li>
                          <li>
                            <a href="hosting-details.html" className="sub-link">
                              Hosting Details
                            </a>
                          </li>
                          <li>
                            <a href="team.html" className="sub-link">
                              Team
                            </a>
                          </li>
                          <li>
                            <a href="team-details.html" className="sub-link">
                              Team Details
                            </a>
                          </li>
                          <li>
                            <a href="domain-checker.html" className="sub-link">
                              Domain Checker
                            </a>
                          </li>
                          <li>
                            <a href="domain-transfer.html" className="sub-link">
                              Domain Transfer
                            </a>
                          </li>
                          <li>
                            <a href="domain-register.html" className="sub-link">
                              Domain Register
                            </a>
                          </li>
                          <li>
                            <a href="ssl-certificate.html" className="sub-link">
                              SSL Certificate
                            </a>
                          </li>
                          <li>
                            <a href="support.html" className="sub-link">
                              Support
                            </a>
                          </li>
                          <li>
                            <a href="whoic.html" className="sub-link">
                              Whoic
                            </a>
                          </li>
                          <li>
                            <a href="price.html" className="sub-link">
                              Price
                            </a>
                          </li>
                          <li>
                            <a href="faq.html" className="sub-link">
                              FAQ
                            </a>
                          </li>
                          <li>
                            <a href="404.html" className="sub-link">
                              404
                            </a>
                          </li>
                        </ul>
                      </div>
                    </li>
                    <li>
                      <div className="overflow-hidden">
                        <a href="#" className="link cursor-pointer dmenu">
                          <span className="fill-text" data-text="Portfolio">
                            Portfolio
                          </span>{" "}
                          <i />
                        </a>
                      </div>
                      <div className="sub-menu">
                        <ul>
                          <li>
                            <a href="portfolio.html" className="sub-link">
                              Portfolio
                            </a>
                          </li>
                          <li>
                            <a
                              href="portfolio-details.html"
                              className="sub-link"
                            >
                              Portfolio Details
                            </a>
                          </li>
                        </ul>
                      </div>
                    </li>
                    <li>
                      <div className="overflow-hidden">
                        <a href="#" className="link cursor-pointer dmenu">
                          <span className="fill-text" data-text="Blog">
                            Blog
                          </span>{" "}
                          <i />
                        </a>
                      </div>
                      <div className="sub-menu">
                        <ul>
                          <li>
                            <a href="blog.html" className="sub-link">
                              Blog
                            </a>
                          </li>
                          <li>
                            <a href="blog-2.html" className="sub-link">
                              Blog Sidebar
                            </a>
                          </li>
                          <li>
                            <a href="blog-3.html" className="sub-link">
                              Blog Classic
                            </a>
                          </li>
                          <li>
                            <a href="blog-details.html" className="sub-link">
                              Blog Details
                            </a>
                          </li>
                        </ul>
                      </div>
                    </li>
                    <li>
                      <div className="overflow-hidden">
                        <a
                          href="contact.html"
                          className="link cursor-pointer dmenu"
                        >
                          <span className="fill-text" data-text="Contact">
                            Contact
                          </span>
                        </a>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="cont-info">
                  <div className="item mb-50">
                    <h6 className="sub-title mb-15">Address</h6>
                    <h5>
                      541 Melville Geek, <br /> Palo Alto, CA 94301
                    </h5>
                  </div>
                  <div className="item mb-50">
                    <h6 className="sub-title mb-15">Social Media</h6>
                    <ul className="social">
                      <li className="mb-10">
                        <a href="#0" className="hover-this">
                          <span className="hover-anim">Facebook</span>
                        </a>
                      </li>
                      <li className="mb-10">
                        <a href="#0" className="hover-this">
                          <span className="hover-anim">Twitter</span>
                        </a>
                      </li>
                      <li className="mb-10">
                        <a href="#0" className="hover-this">
                          <span className="hover-anim">LinkedIn</span>
                        </a>
                      </li>
                      <li>
                        <a href="#0" className="hover-this">
                          <span className="hover-anim">Instagram</span>
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div className="item mb-40">
                    <h6 className="sub-title mb-15">Contact Us</h6>
                    <h5>
                      <a href="maito:hello@zeniqscom">hello@zeniqscom</a>
                    </h5>
                    <h5 className="underline mt-10">
                      <a href="tel:+704-555-0127">(+704) 555-0127</a>
                    </h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> */}
        {/* ==================== End Navbar ==================== */}
        {/* search start area */}
        {/* <div className="ba-search-popup">
          <div className="ba-color-layer" />
          <div className="ba-search-popup-inner">
            <form action="#">
              <input
                type="text"
                placeholder="Search here..."
                name="search"
                id="search-input"
              />
              <button type="submit">
                <i className="fal fa-search" />
              </button>
            </form>
          </div>
        </div> */}
        {/* search start end */}
        <div className="has-smooth" id="has_smooth" />
        <div id="smooth-wrapper">
          <div id="smooth-content">
            <div className="body-wrapper">
              {/* Start Main Header */}
              <header className="h4_nh_header-area">
                <div className="container container_custom-1">
                  <div className="h4_nh_header-wrap">
                    <div className="h4_nh_header-logo">
                      <a href="/">
                        <img src="/images/logo.png" alt="logo" width={170} />
                      </a>
                    </div>
                    <div className={headerTypeCss}>
                      <nav id="mobile-menu">
                        <ul>
                          <li>
                            <a href="/">Home</a>
                          </li>
                          <li>
                            <a href="/about_us">About Us</a>
                          </li>
                          <li className="menu-has-child">
                            <a href="#">Services</a>
                            <ul className="submenu">
                              <li>
                                <a href="/our_services">Mobile Recharge</a>
                              </li>
                              <li>
                                <a href="/our_services">DTH Recharge</a>
                              </li>
                              <li>
                                <a href="/our_services">Google Play Recharge</a>
                              </li>
                            </ul>
                          </li>
                          <li className="menu-has-child">
                            <a href="#">Pages</a>
                            <ul className="submenu">
                              <li>
                                <a href="/terms_and_conditions">
                                  Terms and Conditions
                                </a>
                              </li>
                              <li>
                                <a href="/privacy_policy">Privacy Policy</a>
                              </li>
                              <li>
                                <a href="/refund_policy">Refund Policy</a>
                              </li>
                              <li>
                                <a href="/grievance_policy">Grievance Policy</a>
                              </li>
                            </ul>
                          </li>

                          <li>
                            <a href="/contact_us">Contact Us</a>
                          </li>
                        </ul>
                      </nav>
                    </div>
                    <div className="h4_nh_header-action">
                      <a
                        href="https://app.mitrarecharge.com/#/login"
                        className="btn btn-secondary"
                      >
                        Login
                      </a>
                    </div>
                  </div>
                </div>
              </header>
              {/* Start Main Header */}
            </div>
          </div>
        </div>
      </>
    </React.Fragment>
  );
};

export default Header;
